/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import React from 'react';

import { InputLabel } from 'src/shared/components/form-elements/input-label';
import { ErrorMessage } from 'src/shared/components/form-elements/error-message';
import { getUserEventAttr } from 'src/shared/helpers/tracking-user-events';

export function SelectShell({
    label,
    children,
    inputId,
    errorMessage,
    userEvent,
}: {
    label?: React.ReactNode;
    inputId?: string;
    children: React.ReactNode;
    errorMessage?: React.ReactNode;
    userEvent?: string;
}) {
    return (
        <div
            sx={{
                fontFamily: 'normal',
            }}
        >
            {label && <InputLabel text={label} inputId={inputId} />}
            <div {...getUserEventAttr(userEvent)}>{children}</div>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </div>
    );
}
